import React from 'react';
import PropTypes from 'prop-types';


const AlertPopup = ({ message, title, type, onClose, duration }) => {
  const [isOpen, setIsOpen] = React.useState(true);
  const resolvedDuration = type === 'error' ? Math.max(duration, 7000) : duration;

  React.useEffect(() => {
    const timer = setTimeout(() => {
      setIsOpen(false);
      onClose();
    }, resolvedDuration);

    return () => {
      clearTimeout(timer);
    };
  }, [resolvedDuration, onClose]);

  const getAlertBgColor = () => {
    switch (type) {
      case 'success':
        return 'bg-green-100';
      case 'error':
        return 'bg-red-100';
      default:
        return 'bg-gray-100';
    }
  };

  const getAlertTextColor = () => {
    switch (type) {
      case 'success':
        return 'text-green-800';
      case 'error':
        return 'text-red-800';
      default:
        return 'text-gray-800';
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className={`fixed bottom-4 right-4 max-w-md p-4 rounded-md shadow-lg ${getAlertBgColor()}`} role="alert" aria-live="assertive">
      <div className="flex items-center">
        <div className="flex flex-col gap-1">
          {title ? <span className={`text-sm font-semibold ${getAlertTextColor()}`}>{title}</span> : null}
          <span className={`text-sm font-medium ${getAlertTextColor()}`}>{message}</span>
        </div>
        <button
          className="ml-auto text-gray-500 hover:text-gray-700 focus:outline-none"
          onClick={() => {
            setIsOpen(false);
            onClose();
          }}
        >
        </button>
      </div>
    </div>
  );
};

AlertPopup.propTypes = {
  message: PropTypes.string.isRequired,
  title: PropTypes.string,
  type: PropTypes.oneOf(['success', 'error']),
  onClose: PropTypes.func,
  duration: PropTypes.number,
};

AlertPopup.defaultProps = {
  type: 'success',
  title: '',
  onClose: () => {},
  duration: 3000,
};

export default AlertPopup;



